import React from "react"
import { FormattedMessage } from "react-intl"
import { Grid, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyle = makeStyles(theme => ({
  announce: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#333333",
    lineHeight: "20px",
    textAlign: "center",
    paddingTop: "5px",
    paddingBottom: "20px",
    position: "relative",
  },
}))

const CampaignAnnounce = () => {
  const classes = useStyle()

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <Box className={classes.announce} id="announce">
          <FormattedMessage
            id="AgreementSelectionContents.AnnounceText1"
            values={{ linebreak: <br /> }}
          />
          <FormattedMessage id="AgreementSelectionContents.LinkText1" />
          <FormattedMessage
            id="AgreementSelectionContents.AnnounceText2"
            values={{ linebreak: <br /> }}
          />
          <FormattedMessage id="AgreementSelectionContents.AnnounceText3" />
        </Box>
      </Grid>
    </Grid>
  )
}

export default CampaignAnnounce
